"use strict";

exports.__esModule = true;
exports["default"] = exports.GalleryContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var actions = _interopRequireWildcard(require("../../actions/galleryActions.js"));

var _videoActionTypes = _interopRequireDefault(require("../../constants/videoActionTypes"));

var _galleryView = _interopRequireDefault(require("./galleryView.js"));

var _slideshowView = _interopRequireDefault(require("./slideshowView.js"));

var _layoutHelper = require("../helpers/layoutHelper");

var _itemsHelper = require("../helpers/itemsHelper");

var _dimensionsHelper = _interopRequireDefault(require("../helpers/dimensionsHelper"));

var _scrollHelper = require("../helpers/scrollHelper");

var _itemViewActions = require("../../actions/itemViewActions.js");

var _windowWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/windowWrapper"));

var _galleryCssScrollIndicator = _interopRequireDefault(require("./galleryCssScrollIndicator"));

var _proGalleryLayouter = require("pro-gallery-layouter");

var _cssScrollHelper = require("../helpers/cssScrollHelper.js");

var _cssLayoutsHelper = require("../helpers/cssLayoutsHelper.js");

var _experimentsWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/experimentsWrapper"));

var _lodash = _interopRequireDefault(require("lodash"));

var _utils = _interopRequireDefault(require("../../utils"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var GalleryContainer =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(GalleryContainer, _React$Component);

  function GalleryContainer(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    if (_utils["default"].isVerbose()) {
      console.count('[OOISSR] galleryContainerNew constructor', _windowWrapper["default"].isMock);
    }

    _this.getMoreItemsIfNeeded = _this.getMoreItemsIfNeeded.bind(_assertThisInitialized(_this));
    _this.enableScrollPreload = _this.enableScrollPreload.bind(_assertThisInitialized(_this));
    _this.toggleInfiniteScroll = _this.toggleInfiniteScroll.bind(_assertThisInitialized(_this)); //TODO check if needed

    _this.scrollToItem = _this.scrollToItem.bind(_assertThisInitialized(_this));
    _this.onItemClicked = typeof props.onItemClicked === 'function' ? function (itemIdx) {
      return _this.props.onItemClicked(_this.galleryStructure.galleryItems[itemIdx]);
    } : function () {};
    _this.onCurrentItemChanged = typeof props.onCurrentItemChanged === 'function' ? function (itemIdx) {
      return _this.props.onCurrentItemChanged(_this.galleryStructure.galleryItems[itemIdx]);
    } : function () {};
    _this._scrollingElement = _this.getScrollingElement();
    _this.setCurrentHover = _this.setCurrentHover.bind(_assertThisInitialized(_this));
    _this.duplicateGalleryItems = _this.duplicateGalleryItems.bind(_assertThisInitialized(_this));
    var initialState = {
      pgScroll: 0,
      showMoreClicked: false,
      currentHover: -1,
      gotFirstScrollEvent: !(0, _experimentsWrapper["default"])('specs.pro-gallery.dynamicScrollPreloading')
    };
    _this.items = [];
    _this.itemsDimensions = {};
    _this.preloadedItems = {};
    _this.fullwidthLayoutsCss = [];
    _this.state = initialState;

    if (_utils["default"].isSSR()) {
      _this.initialGalleryState = _this.reCreateGalleryExpensively(props, initialState);

      try {
        _this.galleryInitialStateJson = JSON.stringify(_this.initialGalleryState);
      } catch (e) {
        //todo - report to sentry
        _this.galleryInitialStateJson = null;
      }
    } else {
      try {
        if (!_utils["default"].shouldDebug('no_hydrate')) {
          var state = JSON.parse(_windowWrapper["default"].document.querySelector("#pro-gallery-" + props.domId + " #ssr-state-to-hydrate").innerHTML);

          _this.reCreateGalleryFromState({
            items: props.items,
            styles: state.styles,
            container: state.container,
            gotFirstScrollEvent: initialState.gotFirstScrollEvent
          });

          _this.initialGalleryState = state;
        } else {
          _this.initialGalleryState = {}; //this will cause a flicker between ssr and csr
        }
      } catch (e) {
        //todo - report to sentry
        _this.initialGalleryState = {};
      }
    }

    _this.state = _objectSpread({}, initialState, _this.initialGalleryState);

    try {
      if (typeof _this.props.registerToComponentDidLayout === 'function') {
        _this.props.registerToComponentDidLayout(_this.componentDidLayout.bind(_assertThisInitialized(_this)));
      }
    } catch (e) {
      console.error('Could not register to componentDidLayot', e);
    }

    return _this;
  }

  var _proto = GalleryContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.getMoreItemsIfNeeded(0);
    var galleryState = this.reCreateGalleryExpensively(this.props);
    this.loadItemsDimensionsIfNeeded();

    if (Object.keys(galleryState).length > 0) {
      this.setState(galleryState, function () {
        _this2.handleNewGalleryStructure();
      });
    }
  };

  _proto.componentDidLayout = function componentDidLayout() {
    var _this3 = this;

    var galleryState = this.reCreateGalleryExpensively(this.props);

    if (Object.keys(galleryState).length > 0) {
      this.setState(galleryState, function () {
        _this3.handleNewGalleryStructure();
      });
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this4 = this;

    var reCreateGallery = function reCreateGallery() {
      var galleryState = _this4.reCreateGalleryExpensively(nextProps);

      if (Object.keys(galleryState).length > 0) {
        _this4.setState(galleryState, function () {
          _this4.handleNewGalleryStructure();
        });
      }
    };

    var getSignificantProps = function getSignificantProps(props) {
      var domId = props.domId,
          styles = props.styles,
          container = props.container,
          items = props.items;
      return {
        domId: domId,
        styles: styles,
        container: container,
        items: items
      };
    };

    if (this.reCreateGalleryTimer) {
      clearTimeout(this.reCreateGalleryTimer);
    }

    var hasPropsChanged = true;

    try {
      hasPropsChanged = JSON.stringify(getSignificantProps(this.props)) !== JSON.stringify(getSignificantProps(nextProps));
    } catch (e) {
      console.error('Cannot compare props', e);
    }

    if (hasPropsChanged) {
      if (_utils["default"].isVerbose()) {
        console.log('New props arrived', _utils["default"].printableObjectsDiff(this.props, nextProps));
      }

      reCreateGallery();

      if (!!nextProps.currentIdx && nextProps.currentIdx > 0) {
        this.scrollToItem(nextProps.currentIdx, false, true, 0);
      }

      if (this.props.isInDisplay !== nextProps.isInDisplay) {
        this.handleNavigation(nextProps.isInDisplay);
      }
    } else {
      //this is a hack, because in fullwidth, new props arrive without any changes
      this.reCreateGalleryTimer = setTimeout(reCreateGallery, 1000);
    }
  };

  _proto.loadItemsDimensionsIfNeeded = function loadItemsDimensionsIfNeeded() {
    var _this5 = this;

    if (_utils["default"].isSSR()) {
      return;
    }

    if (!(this.galleryStructure && this.galleryStructure.galleryItems && this.galleryStructure.galleryItems.length > 0)) {
      return;
    }

    var galleryItems = this.galleryStructure.galleryItems;
    var itemsWithoutDimensions = galleryItems.filter(function (item, idx) {
      try {
        return item.isVisible && item.isDimensionless && !item.isPreloaded;
      } catch (e) {
        return false;
      }
    });

    if (!itemsWithoutDimensions.length) {
      return;
    }

    var preloadItem = function preloadItem(item, onload) {
      if (!item || !item.itemId || !item.isGalleryItem) {
        return;
      }

      try {
        var id = item.itemId;

        if (_this5.itemsDimensions[id]) {
          return; //already measured
        }

        if (typeof _this5.preloadedItems[id] !== 'undefined') {
          return;
        }

        _this5.preloadedItems[id] = new Image();

        if (_utils["default"].isVerbose()) {
          console.log('Preloading item #' + item);
        }

        _this5.preloadedItems[id].src = item.preload_url;

        if (typeof onload === 'function') {
          _this5.preloadedItems[id].onload = function (e) {
            onload(e);
          };
        }

        return _this5.preloadedItems[id];
      } catch (e) {
        console.error('Could not preload item', item, e);
        return;
      }
    };

    var throttledReCreateGallery = _lodash["default"].throttle(function () {
      var _this5$props = _this5.props,
          items = _this5$props.items,
          styles = _this5$props.styles,
          container = _this5$props.container,
          watermarkData = _this5$props.watermarkData;
      var params = {
        items: items,
        styles: styles,
        container: container,
        watermarkData: watermarkData,
        itemsDimensions: _this5.itemsDimensions
      };

      var newState = _this5.reCreateGalleryExpensively(params, _this5.state);

      if (Object.keys(newState).length > 0) {
        _this5.setState(newState, function () {
          _this5.handleNewGalleryStructure();
        });
      }
    }, 2500);

    itemsWithoutDimensions.forEach(function (item, idx, items) {
      item.isPreloaded = true;
      preloadItem(item, function (e) {
        try {
          if (_utils["default"].isVerbose()) {
            console.log('item loaded event', idx, e);
          }

          var ele = e.srcElement;

          var _item = _this5.items.find(function (itm) {
            return itm.itemId === item.itemId;
          });

          if (_item) {
            var itemDim = {
              width: ele.width,
              height: ele.height,
              measured: true
            };
            Object.assign(_item, itemDim);

            if (typeof _item.metaData === 'object') {
              Object.assign(_item.metaData, itemDim);
            }

            _this5.itemsDimensions[_item.itemId] = itemDim; //rebuild the gallery after every dimension update
            // if (Object.keys(this.itemsDimensions).length > 0) {

            throttledReCreateGallery(); // }
          }
        } catch (e) {
          console.error('Could not calc element dimensions', e);
        }
      });
    });
  };

  _proto.handleNavigation = function handleNavigation(isInDisplay) {
    if (isInDisplay) {
      this.props.store.dispatch(actions.toggleIsInView(true));
    } else {
      this.props.store.dispatch(actions.toggleIsInView(false));
      this.props.store.dispatch((0, _itemViewActions.pauseVideo)());
    }
  };

  _proto.handleNewGalleryStructure = function handleNewGalleryStructure() {
    //should be called AFTER new state is set
    if (typeof this.props.handleNewGalleryStructure === 'function') {
      var container = this.state.container;

      var partialStyleParams = _lodash["default"].pick(this.state.styles, ['isSlideshow', 'slideshowInfoSize', 'galleryThumbnailsAlignment', 'thumbnailSize', 'isSlider', 'galleryWidth', 'isInAdi', 'oneRow', 'enableInfiniteScroll']);

      var numOfItems = this.state.items.length;
      var layoutHeight = this.layout.height;
      var isInfinite = this.containerGrowthDirection() === 'vertical';
      this.props.handleNewGalleryStructure({
        numOfItems: numOfItems,
        container: container,
        partialStyleParams: partialStyleParams,
        layoutHeight: layoutHeight,
        isInfinite: isInfinite
      });
    }
  };

  _proto.isNew = function isNew(_ref, state) {
    var _this6 = this;

    var items = _ref.items,
        styles = _ref.styles,
        container = _ref.container,
        watermarkData = _ref.watermarkData,
        itemsDimensions = _ref.itemsDimensions;
    var reason = {
      items: '',
      itemsMetadata: '',
      itemsAdded: '',
      styles: '',
      container: ''
    };

    var containerHadChanged = function containerHadChanged(container) {
      if (!state.styles || !state.container) {
        reason.container = 'no old container or styles. ';
        return true; //no old container or styles (style may change container)
      }

      if (!container) {
        reason.container = 'no new container.';
        return false; // no new continainer
      }

      var containerHasChanged = {
        height: !state.styles.oneRow && state.styles.enableInfiniteScroll ? false : !!container.height && container.height !== _this6.props.container.height,
        width: !state.container || _dimensionsHelper["default"].isFullWidth(container) && _windowWrapper["default"].innerWidth !== state.container.windowWidth || !!container.width && container.width !== _this6.props.container.width,
        scrollBase: !!container.scrollBase && container.scrollBase !== _this6.props.container.scrollBase,
        documentHeight: !state.container || _windowWrapper["default"].document.body.scrollHeight !== state.container.documentHeight
      };
      return Object.keys(containerHasChanged).reduce(function (is, key) {
        if (containerHasChanged[key]) {
          reason.container += "container." + key + " has changed. ";
        }

        return is || containerHasChanged[key];
      }, false);
    };

    var stylesHaveChanged = function stylesHaveChanged(styles) {
      if (!styles) {
        reason.styles = 'no new styles.';
        return false; //no new styles - use old styles
      }

      if (!state.styles) {
        reason.styles = 'no old styles.';
        return true; //no old styles
      }

      try {
        var wasChanged = JSON.stringify(styles) !== JSON.stringify(_this6.props.styles);

        if (wasChanged) {
          reason.styles = 'styles were changed.';
        }

        return wasChanged;
      } catch (e) {
        console.error('Could not compare styles', e);
        return false;
      }
    };

    var itemsWereAdded = function itemsWereAdded(items) {
      var existingItems = _this6.items;

      if (items === _this6.items) {
        reason.itemsAdded = 'items are the same object.';
        return false; //it is the exact same object
      }

      if (!items) {
        reason.itemsAdded = 'new items do not exist.';
        return false; // new items do not exist (use old items)
      }

      if (!state.items || !existingItems) {
        reason.itemsAdded = 'old items do not exist.';
        return false; // old items do not exist (it is not items addition)
      }

      if (existingItems.length >= items.length) {
        reason.itemsAdded = 'more old items than new items.';
        return false; // more old items than new items
      }

      var idsNotChanged = existingItems.reduce(function (is, _item, idx) {
        //check that all the existing items exist in the new array
        return is && _item.id === items[idx].itemId;
      }, true);

      if (!idsNotChanged) {
        reason.itemsAdded = 'items ids were changed. ';
      }

      return idsNotChanged;
    };

    var itemsHaveChanged = function itemsHaveChanged(newItems) {
      var existingItems = _this6.items;

      if (newItems === _this6.items) {
        reason.items = 'items are the same object.';
        return false; //it is the exact same object
      }

      if (!newItems) {
        reason.items = 'new items do not exist.';
        return false; // new items do not exist (use old items)
      }

      if (!state.items || !existingItems) {
        reason.items = 'old items do not exist.';
        return true; // old items do not exist
      }

      if (existingItems.length !== newItems.length) {
        reason.items = 'more new items than old items (or vice versa).';
        return true; // more new items than old items (or vice versa)
      }

      return newItems.reduce(function (is, newItem, idx) {
        //check that all the items are identical
        var existingItem = existingItems[idx];

        try {
          var itemsChanged = is || !newItem || !existingItem || newItem.itemId !== existingItem.itemId || newItem.mediaUrl !== existingItem.mediaUrl;

          if (itemsChanged) {
            reason.items = "items #" + idx + " id was changed.";
          }

          return itemsChanged;
        } catch (e) {
          reason.items = 'an error occured';
          return true;
        }
      }, false);
    };

    var itemsMetadataWasChanged = function itemsMetadataWasChanged(newItems) {
      var existingItems = _this6.items;

      if (!newItems) {
        reason.itemsMetadata = 'new items do not exist.';
        return false; // new items do not exist (use old items)
      }

      if (!state.items || !existingItems) {
        reason.itemsMetadata = 'old items do not exist.';
        return true; // old items do not exist
      }

      return newItems.reduce(function (is, newItem, idx) {
        //check that all the items are identical
        var existingItem = existingItems[idx];

        try {
          var itemsChanged = is || JSON.stringify(newItem.metaData) !== JSON.stringify(existingItem.metaData);

          if (itemsChanged) {
            reason.itemsMetadata = "item #" + idx + " data was changed.";
          }

          return itemsChanged;
        } catch (e) {
          reason.itemsMetadata = 'an error occured.';
          return true;
        }
      }, false);
    };

    var isNew = {
      items: itemsHaveChanged(items),
      addedItems: itemsWereAdded(items),
      itemsMetadata: itemsMetadataWasChanged(items),
      styles: stylesHaveChanged(styles),
      container: containerHadChanged(container),
      itemsDimensions: !!itemsDimensions,
      watermark: !!watermarkData && watermarkData !== this.props.watermarkData
    };
    isNew.str = Object.entries(isNew).map(function (_ref2) {
      var key = _ref2[0],
          is = _ref2[1];
      return is ? key : '';
    }).filter(function (str) {
      return !!str;
    }).join('|');
    isNew.any = isNew.str.length > 0;
    isNew.reason = reason; // if (!isNew.any) {
    //   console.count('Tried recreating gallery with no new params');
    // } else {
    //   console.count('Recreating gallery with new params');
    // }

    return isNew;
  };

  _proto.reCreateGalleryFromState = function reCreateGalleryFromState(_ref3) {
    var items = _ref3.items,
        styles = _ref3.styles,
        container = _ref3.container,
        gotFirstScrollEvent = _ref3.gotFirstScrollEvent;
    //update this.items
    this.items = items.map(function (item) {
      return _itemsHelper.ItemsHelper.convertDtoToLayoutItem(item);
    });
    var layoutParams = {
      items: this.items,
      container: container,
      styleParams: styles,
      gotScrollEvent: true,
      options: {
        showAllItems: true,
        skipVisibilitiesCalc: true,
        useLayoutStore: false,
        createLayoutOnInit: false
      }
    };
    this.layouter = new _proGalleryLayouter.Layouter(layoutParams);
    this.layout = this.layouter.createLayout(layoutParams);
    this.galleryStructure = _itemsHelper.ItemsHelper.convertToGalleryItems(this.layout, {
      sharpParams: styles.sharpParams
    });
    var allowPreloading = _utils["default"].isEditor() || gotFirstScrollEvent;
    this.scrollCss = this.getScrollCssIfNeeded({
      galleryDomId: this.props.domId,
      items: this.galleryStructure.galleryItems,
      styleParams: styles,
      allowPreloading: allowPreloading
    });
  };

  _proto.reCreateGalleryExpensively = function reCreateGalleryExpensively(_ref4, curState) {
    var _this7 = this;

    var items = _ref4.items,
        styles = _ref4.styles,
        container = _ref4.container,
        watermarkData = _ref4.watermarkData,
        itemsDimensions = _ref4.itemsDimensions;

    if (_utils["default"].isVerbose()) {
      console.count('PROGALLERY [COUNT] reCreateGalleryExpensively');
      console.time('PROGALLERY [TIME] reCreateGalleryExpensively');
    }

    var state = curState || this.state || {};

    var isFullwidth = _dimensionsHelper["default"].isFullWidth(container); //keep this on top, before the container is recalculated


    var _styles, _container;

    var isNew = this.isNew({
      items: items,
      styles: styles,
      container: container,
      watermarkData: watermarkData,
      itemsDimensions: itemsDimensions
    }, state);
    var newState = {};

    if (_utils["default"].isVerbose()) {
      console.log('PROGALLERY reCreateGalleryExpensively', isNew, {
        items: items,
        styles: styles,
        container: container,
        watermarkData: watermarkData
      });
    }

    if ((isNew.itemsDimensions || isNew.itemsMetadata) && !isNew.items && !isNew.addedItems) {
      //if only the items metadata has changed - use the modified items (probably with the measured width and height)
      this.items = this.items.map(function (item) {
        return Object.assign(item, _objectSpread({}, _this7.itemsDimensions[item.itemId]));
      });
      newState.items = this.items.map(function (item) {
        return item.itemId;
      });
    } else if (isNew.items && !isNew.addedItems) {
      this.items = items.map(function (item) {
        return Object.assign(_itemsHelper.ItemsHelper.convertDtoToLayoutItem(item), _objectSpread({}, _this7.itemsDimensions[item.itemId]));
      });
      newState.items = this.items.map(function (item) {
        return item.itemId;
      });
      this.gettingMoreItems = false; //probably finished getting more items
    } else if (isNew.addedItems) {
      this.items = this.items.concat(items.slice(this.items.length).map(function (item) {
        return _itemsHelper.ItemsHelper.convertDtoToLayoutItem(item);
      }));
      newState.items = this.items.map(function (item) {
        return item.itemId;
      });
      this.gettingMoreItems = false; //probably finished getting more items
    }

    if (isNew.styles || isNew.container) {
      styles = styles || state.styles;
      container = container || state.container;

      _dimensionsHelper["default"].updateParams({
        styles: styles,
        container: container,
        domId: this.props.domId
      });

      _styles = (0, _layoutHelper.addLayoutStyles)(styles, container);

      _dimensionsHelper["default"].updateParams({
        styles: _styles
      });

      _container = Object.assign({}, container, _dimensionsHelper["default"].getGalleryDimensions(container));

      _dimensionsHelper["default"].updateParams({
        container: _container
      });

      newState.styles = _styles;
      newState.container = _container;
    } else {
      _styles = state.styles;
      _container = state.container;
    }

    if (!this.galleryStructure || isNew.any) {
      if (_utils["default"].isVerbose()) {
        console.count('PROGALLERY [COUNT] - reCreateGalleryExpensively (isNew)');
      }

      var layoutParams = {
        items: this.items,
        container: _container,
        styleParams: _styles,
        gotScrollEvent: true,
        options: {
          showAllItems: true,
          skipVisibilitiesCalc: true,
          useLayoutStore: false
        }
      };

      if (this.layouter && isNew.addedItems) {
        layoutParams.options.useExistingLayout = true;
      } else {
        layoutParams.options.createLayoutOnInit = false;
        this.layouter = new _proGalleryLayouter.Layouter(layoutParams);
      }

      this.props.store.dispatch({
        type: _videoActionTypes["default"].videoModeChanged,
        payload: _styles.videoPlay
      });
      this.layout = this.layouter.createLayout(layoutParams);

      if (isNew.addedItems) {
        var existingLayout = this.galleryStructure || this.layout;
        this.galleryStructure = _itemsHelper.ItemsHelper.convertExistingStructureToGalleryItems(existingLayout, this.layout, {
          watermark: watermarkData,
          sharpParams: _styles.sharpParams,
          lastVisibleItemIdx: this.lastVisibleItemIdx
        });
      } else {
        this.galleryStructure = _itemsHelper.ItemsHelper.convertToGalleryItems(this.layout, {
          watermark: watermarkData,
          sharpParams: _styles.sharpParams,
          lastVisibleItemIdx: this.lastVisibleItemIdx
        });
      }

      if (isNew.items) {
        this.loadItemsDimensionsIfNeeded();
      }

      if (_utils["default"].isSSR() && isFullwidth && !_styles.oneRow) {
        if (_utils["default"].isVerbose()) {
          console.time('fullwidthLayoutsCss!');
        }

        this.fullwidthLayoutsCss = (0, _cssLayoutsHelper.createCssLayouts)(layoutParams, _utils["default"].isMobile());

        if (_utils["default"].isVerbose()) {
          console.timeEnd('fullwidthLayoutsCss!');
        }
      } else {
        this.fullwidthLayoutsCss = [];
      }

      var allowPreloading = _utils["default"].isEditor() || state.gotFirstScrollEvent || state.showMoreClicked;
      this.scrollCss = this.getScrollCssIfNeeded({
        galleryDomId: this.props.domId,
        items: this.galleryStructure.galleryItems,
        styleParams: _styles,
        allowPreloading: allowPreloading
      });
    }

    if (_utils["default"].isVerbose()) {
      console.log('PROGALLERY [RENDERS] - reCreateGalleryExpensively', {
        isNew: isNew
      }, {
        items: items,
        styles: styles,
        container: container,
        watermarkData: watermarkData
      });
      console.timeEnd('PROGALLERY [TIME] reCreateGalleryExpensively');
    }

    if (isNew.any) {
      return newState;
    } else {
      return {};
    }
  };

  _proto.getScrollingElement = function getScrollingElement() {
    var _this8 = this;

    var horizontal = function horizontal() {
      return _windowWrapper["default"].document.querySelector("#pro-gallery-" + _this8.props.domId + " #gallery-horizontal-scroll");
    };

    var vertical = this.props.scrollingElement ? typeof this.props.scrollingElement === 'function' ? this.props.scrollingElement : function () {
      return _this8.props.scrollingElement;
    } : function () {
      return _windowWrapper["default"];
    };
    return {
      vertical: vertical,
      horizontal: horizontal
    };
  };

  _proto.scrollToItem = function scrollToItem(itemIdx, fixedScroll, isManual, durationInMS) {
    if (durationInMS === void 0) {
      durationInMS = 0;
    }

    var scrollingElement = this._scrollingElement;
    var horizontalElement = scrollingElement.horizontal();
    (0, _scrollHelper.scrollToItemImp)({
      oneRow: this.state.styles.oneRow,
      galleryWidth: this.state.container.galleryWidth,
      galleryHeight: this.state.container.galleryHeight,
      top: 0,
      items: this.galleryStructure.items,
      itemIdx: itemIdx,
      fixedScroll: fixedScroll,
      isManual: isManual,
      scrollingElement: scrollingElement,
      horizontalElement: horizontalElement,
      durationInMS: durationInMS
    });
  };

  _proto.containerGrowthDirection = function containerGrowthDirection(styles) {
    if (styles === void 0) {
      styles = false;
    }

    var _styles = styles || this.state.styles; // return the direction in which the gallery can grow on it's own (aka infinite scroll)


    var enableInfiniteScroll = this.props.styles.enableInfiniteScroll;
    var showMoreClicked = this.state.showMoreClicked;
    var oneRow = _styles.oneRow;

    if (oneRow) {
      return 'horizontal';
    } else if (!enableInfiniteScroll && !showMoreClicked) {
      return 'none'; //vertical gallery with showMore button enabled and not clicked
    } else {
      return 'vertical';
    }
  };

  _proto.getScrollCssIfNeeded = function getScrollCssIfNeeded(_ref5) {
    var galleryDomId = _ref5.galleryDomId,
        items = _ref5.items,
        styleParams = _ref5.styleParams,
        allowPreloading = _ref5.allowPreloading;
    var isSEO = _utils["default"].isSEOBot() || _experimentsWrapper["default"] && (0, _experimentsWrapper["default"])('specs.pro-gallery.SEOBotView') === 'true';
    var shouldUseScrollCss = !isSEO;

    if (shouldUseScrollCss) {
      return _cssScrollHelper.cssScrollHelper.calcScrollCss({
        galleryDomId: galleryDomId,
        items: items,
        styleParams: styleParams,
        allowPreloading: allowPreloading
      });
    } else {
      return '';
    }
  };

  _proto.toggleInfiniteScroll = function toggleInfiniteScroll(forceVal) {
    var _this9 = this;

    if (forceVal !== this.state.showMoreClicked) {
      //forceVal is undefined or different than existing val
      var showMoreClicked = forceVal || !this.state.showMoreClicked;

      if (!this.state.gotFirstScrollEvent) {
        //we already called to calcScrollCss with allowPreloading = true
        this.scrollCss = this.getScrollCssIfNeeded({
          galleryDomId: this.props.domId,
          items: this.galleryStructure.galleryItems,
          styleParams: this.state.styles,
          allowPreloading: true
        });
      }

      this.setState({
        showMoreClicked: showMoreClicked
      }, function () {
        _this9.handleNewGalleryStructure();
      });
    }
  };

  _proto.setCurrentHover = function setCurrentHover(idx) {
    this.setState({
      currentHover: idx
    });
  };

  _proto.enableScrollPreload = function enableScrollPreload() {
    if (!this.state.gotFirstScrollEvent) {
      if (!this.state.showMoreClicked) {
        //we already called to calcScrollCss with allowPreloading = true
        this.scrollCss = this.getScrollCssIfNeeded({
          galleryDomId: this.props.domId,
          items: this.galleryStructure.galleryItems,
          styleParams: this.state.styles,
          allowPreloading: true
        });
      }

      this.setState({
        gotFirstScrollEvent: true
      });
    }
  };

  _proto.duplicateGalleryItems = function duplicateGalleryItems() {
    var _this$items,
        _this10 = this;

    var galleryState = this.reCreateGalleryExpensively(_objectSpread({}, this.props, {
      items: (_this$items = this.items).concat.apply(_this$items, this.items.slice(0, this.props.totalItemsCount))
    }));

    if (Object.keys(galleryState).length > 0) {
      this.setState(galleryState, function () {
        _this10.handleNewGalleryStructure();
      });
    }
  };

  _proto.getMoreItemsIfNeeded = function getMoreItemsIfNeeded(scrollPos) {
    var _this11 = this;

    if (this.galleryStructure && this.galleryStructure.galleryItems && this.galleryStructure.galleryItems.length > 0 && !this.gettingMoreItems && typeof this.props.getMoreItems === 'function' && this.state.items && this.state.styles && this.state.container) {
      //more items can be fetched from the server
      //TODO - add support for horizontal galleries
      var oneRow = this.state.styles.oneRow;

      var _this$galleryStructur = this.galleryStructure.galleryItems.slice(-1),
          lastItem = _this$galleryStructur[0];

      var gallerySize = lastItem.offset[oneRow ? 'right' : 'bottom'];
      var screenSize = oneRow ? _windowWrapper["default"].screen.width : _windowWrapper["default"].screen.height;
      var scrollEnd = scrollPos + screenSize + (oneRow ? 0 : this.state.container.scrollBase);
      var getItemsDistance = 3 * screenSize;

      if (gallerySize - scrollEnd < getItemsDistance) {
        //only when the last item turns visible we should try getting more items
        if (this.state.items.length < this.props.totalItemsCount) {
          this.gettingMoreItems = true;
          this.props.getMoreItems(this.state.items.length);
          setTimeout(function () {
            //wait a bit before allowing more items to be fetched - ugly hack before promises still not working
            _this11.gettingMoreItems = false;
          }, 2000);
        } else if (this.state.styles.slideshowLoop) {
          this.duplicateGalleryItems();
        }
      }
    }
  };

  _proto.canRender = function canRender() {
    var can = this.state.container && this.state.styles && this.state.items;

    if (!can && _utils["default"].isVerbose()) {
      console.log('PROGALLERY [CAN_RENDER] GalleryContainer', this.state, can, this.state.container, this.state.styles, this.state.items);
    }

    return can;
  };

  _proto.render = function render() {
    if (!this.canRender()) {
      return null;
    }

    var styles = this.state.styles;
    var ViewComponent = styles.oneRow ? _slideshowView["default"] : _galleryView["default"];

    if (_utils["default"].isVerbose()) {
      console.time('PROGALLERY [COUNTS] - GalleryContainer (render)');
      console.log('PROGALLERY [RENDER] - GalleryContainer', this.state.container.scrollBase, {
        state: this.state,
        items: this.items
      });
    }

    var displayShowMore = this.containerGrowthDirection() === 'none';
    var findNeighborItem = this.layouter ? this.layouter.findNeighborItem : _lodash["default"].noop;
    var ssrDisableTransition = !!_utils["default"].isSSR() && 'div.pro-gallery-parent-container * { transition: none !important }';
    return _react["default"].createElement("div", {
      "data-key": "pro-gallery-inner-container",
      key: "pro-gallery-inner-container"
    }, _react["default"].createElement(_galleryCssScrollIndicator["default"], {
      galleryDomId: this.props.domId,
      oneRow: this.state.styles.oneRow,
      scrollBase: this.state.container.scrollBase,
      scrollingElement: this._scrollingElement,
      getMoreItemsIfNeeded: this.getMoreItemsIfNeeded,
      enableScrollPreload: this.enableScrollPreload
    }), _react["default"].createElement(ViewComponent, _extends({
      galleryDomId: this.props.domId,
      galleryId: this.props.galleryId,
      isInDisplay: this.props.isInDisplay,
      scrollingElement: this._scrollingElement,
      totalItemsCount: this.props.totalItemsCount //the items passed in the props might not be all the items
      ,
      renderedItemsCount: this.props.renderedItemsCount,
      items: this.items,
      galleryStructure: this.galleryStructure,
      styleParams: styles,
      container: this.state.container,
      watermark: this.props.watermarkData,
      settings: this.props.settings,
      gotScrollEvent: true,
      scroll: {} //todo: remove after refactor is 100%
      ,
      displayShowMore: displayShowMore,
      domId: this.props.domId,
      currentHover: this.state.currentHover,
      customHoverRenderer: this.props.customHoverRenderer,
      customInfoRenderer: this.props.customInfoRenderer,
      isPremiumSite: this.props.isPremiumSite,
      actions: _lodash["default"].merge(this.props.actions, {
        findNeighborItem: findNeighborItem,
        toggleInfiniteScroll: this.toggleInfiniteScroll,
        onItemClicked: this.onItemClicked,
        onCurrentItemChanged: this.onCurrentItemChanged,
        setWixHeight: _lodash["default"].noop,
        scrollToItem: this.scrollToItem,
        setCurrentHover: this.setCurrentHover,
        setAppLoaded: this.props.setAppLoaded,
        duplicateGalleryItems: this.duplicateGalleryItems,
        itemActions: this.props.itemActions
      }),
      store: this.props.store
    }, this.props.gallery)), this.galleryInitialStateJson && _react["default"].createElement("div", {
      id: "ssr-state-to-hydrate",
      style: {
        display: 'none'
      }
    }, this.galleryInitialStateJson), _react["default"].createElement("style", {
      "data-key": "scrollCss",
      key: "scrollCss"
    }, this.scrollCss), this.fullwidthLayoutsCss.map(function (css, idx) {
      return _react["default"].createElement("style", {
        "data-key": "cssLayout-" + idx,
        key: "cssLayout-" + idx
      }, css);
    }), ssrDisableTransition && _react["default"].createElement("style", null, ssrDisableTransition));
  };

  return GalleryContainer;
}(_react["default"].Component);

exports.GalleryContainer = GalleryContainer;

function mapStateToProps(state) {
  return state.gallery;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)(actions, dispatch)
  };
}

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GalleryContainer);

exports["default"] = _default;